<div class="empty-fav-list-page">
    <div class="container">
        <div class="empty-img"></div>
        <h1>{{ "myFavourites.NoProductHeader" | cxTranslate }}</h1>
    </div>    
</div>